import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';


@Injectable()
export class AssetsService {

    constructor(
        private _iconRegistry: MatIconRegistry,
        private _domSanitizer: DomSanitizer,
    ) { }

    useCustomIcon(name: string, url: string): void;
    useCustomIcon(...icons: { name: string, url: string }[]): void;
    useCustomIcon(...args: [string, string] | { name: string, url: string }[]): void {

        const registrations: { name: string, url: string }[] = typeof args[0] === 'string'
            ? [{ name: args[0], url: args[1] }]
            : <any>args;

        registrations.forEach(reg => {
            this._iconRegistry.addSvgIconInNamespace('sri', reg.name, this._domSanitizer.bypassSecurityTrustResourceUrl(reg.url));
        });
    }

    useMdiIcons(): void {
        // Look for icons here => https://materialdesignicons.com/
        this._iconRegistry.addSvgIconSetInNamespace(
            'mdi',
            this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mdi.svg'),
        );
    }
}
